export class MultiEditError {
    rawMatId: string;
    hasCodeEntitySamePageError: boolean;
    hasCodeEntityDatabaseError: boolean;
    hasReferenceError: boolean;

    hasCodeEntityError() {
        return this.hasCodeEntityDatabaseError || this.hasCodeEntitySamePageError;
    }
}